import React, { useState } from "react";
import { Spinner } from "react-bootstrap";
import { FiLock, FiUser } from "react-icons/fi";
import { useAuth } from "./AuthContext";
import logo from "../components/images/TP-_logo-orizz-claim-color.png";

const LoginPage = () => {
const { loginWithPassword, loginGuest, isGuest } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  

const handleLogin = async (e) => {
  e.preventDefault();
  setError("");
  setLoading(true);

  let res;

  // 🔵 se IP NON autorizzato → login guest
  if (isGuest) {
    res = loginGuest(username, password);
  } else {
    res = await loginWithPassword(username, password);
  }

  setLoading(false);

  if (!res.ok) {
    setError(res.error);
  }
};

  

  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>

        <h3 style={styles.title}>Accesso riservato</h3>

        {error && <div style={styles.error}>{error}</div>}

        <form onSubmit={handleLogin}>

          <div style={styles.inputGroup}>
            <FiUser style={styles.icon} />
            <input
              style={styles.input}
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>

          <div style={styles.inputGroup}>
            <FiLock style={styles.icon} />
            <input
              style={styles.input}
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button style={styles.btn} disabled={loading}>
            {loading ? <Spinner size="sm" /> : "Accedi"}
          </button>

        </form>

        <img src={logo} style={styles.logo} />

      </div>
    </div>
  );
};

const styles = {
  wrapper: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "linear-gradient(135deg,#a01111,#2d2d2d)",
    width: "100%",
  },
  card: {
    background: "#fff",
    padding: 40,
    borderRadius: 20,
    width: 350,
    textAlign: "center",
  },
  title: {
    marginBottom: 20,
    fontWeight: "bold",
  },
  inputGroup: {
    position: "relative",
    marginBottom: 15,
  },
  icon: {
    position: "absolute",
    left: 10,
    top: 12,
    color: "#aaa",
  },
  input: {
    width: "100%",
    padding: "10px 10px 10px 35px",
    borderRadius: 8,
    border: "1px solid #ccc",
  },
  btn: {
    width: "100%",
    padding: 10,
    background: "#b81f25",
    color: "#fff",
    border: "none",
    borderRadius: 8,
    fontWeight: "bold",
  },
  error: {
    background: "#ffe5e5",
    padding: 10,
    marginBottom: 10,
    borderRadius: 8,
    color: "#c00",
  },
  logo: {
    width: 140,
    marginTop: 20,
  },
};

export default LoginPage;